import Image from "next/image";
import { Roboto_Mono } from 'next/font/google';

const robotoMono = Roboto_Mono({
  subsets: ['latin'],
  weight: ['300'],
});

export const ProjectOverview = () => {
  return (
    <div className="flex flex-col items-center justify-end">
      <h1 lang="en"   className={`text-5xl ${robotoMono.className} mb-8`}>Richter{" "}<span className="text-zinc-500">x</span>{" "}AMA</h1>
      <Image 
        style={{ borderRadius: '25% 10%' }}  
        src="/owl-light.png" 
        alt="Hero Image" 
        className="w-3/4 mb-8"
        width={300}
        height={300}
      />
    </div>
  );
};


